/** A wizard step that hosts a curated list of preflight items (Access & team,
 *  Notifications, Booking feed, and the data steps' side items) as SetupItemPanels. */
import { Alert, Stack } from '@mui/material';

import type { PreflightItem } from '@/api/preflight';

import { PreflightPreviewDialog } from '../../tabs/PreflightRunLog';
import type { PreflightItemActions } from '../../tabs/usePreflightItemActions';
import { SetupItemPanel } from '../SetupItemPanel';

interface Props {
  items: PreflightItem[];
  topId: number;
  toCode: string;
  canManage: boolean;
  actions: PreflightItemActions;
  /** Step-level context line rendered above the panels. */
  intro?: string;
}

export function ItemHostStep({ items, topId, toCode, canManage, actions, intro }: Props) {
  if (items.length === 0) {
    return <Alert severity="info">Nothing to do here — not applicable to this operator.</Alert>;
  }
  return (
    <Stack spacing={2}>
      {intro && <Alert severity="info">{intro}</Alert>}
      {items.map((item) => (
        <SetupItemPanel
          key={item.id}
          item={item}
          topId={topId}
          toCode={toCode}
          canManage={canManage}
          actions={actions}
        />
      ))}
      <PreflightPreviewDialog run={actions.previewRun} onClose={actions.clearPreview} />
    </Stack>
  );
}
